import Sagas from 'modules/User/Security/Password/saga'
import Password from 'modules/User/Security/Password/Password'

export default Password

export { Sagas }
